import { useMutation } from '@tanstack/react-query';

import { recognitionServices } from '@hero/services';

export const useDuplicateRecognition = ({ options = {} } = {}) =>
  useMutation(({ code, body }) => recognitionServices.duplicate(code, body), options);
